var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayersicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M3.5 18.7606L17.9633 25.9923C18.1601 26.0907 18.2585 26.1398 18.3617 26.1592C18.4531 26.1764 18.5469 26.1764 18.6383 26.1592C18.7415 26.1398 18.8399 26.0907 19.0367 25.9923L33.5 18.7606M3.5 26.2606L17.9633 33.4923C18.1601 33.5907 18.2585 33.6398 18.3617 33.6592C18.4531 33.6764 18.5469 33.6764 18.6383 33.6592C18.7415 33.6398 18.8399 33.5907 19.0367 33.4923L33.5 26.2606M3.5 11.2606L17.9633 4.02892C18.1601 3.93054 18.2585 3.88134 18.3617 3.86198C18.4531 3.84483 18.5469 3.84483 18.6383 3.86198C18.7415 3.88134 18.8399 3.93054 19.0367 4.02892L33.5 11.2606L19.0367 18.4923C18.8399 18.5907 18.7415 18.6398 18.6383 18.6592C18.5469 18.6764 18.4531 18.6764 18.3617 18.6592C18.2585 18.6398 18.1601 18.5907 17.9633 18.4923L3.5 11.2606Z",
    stroke: "#FFB800",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayersicon);
export default __webpack_public_path__ + "static/media/layers.icon.2ced4c789f12b1e3d741ddceb74efabe.svg";
export { ForwardRef as ReactComponent };